import { checkout } from "../../Data/siteContent";

const BillingFormFields = ({ formData, fieldErrors, handleInputChange, countries }) => (
  <>
    <h2>{checkout.billingShippingTitle}</h2>

    <div className="form-group">
      <label>{checkout.firstNameLabel}</label>
      <input
        type="text"
        name="firstName"
        value={formData.firstName}
        onChange={handleInputChange}
        className={fieldErrors.firstName ? "error-border" : ""}
      />
    </div>
    <div className="form-group">
      <label>{checkout.lastNameLabel}</label>
      <input
        type="text"
        name="lastName"
        value={formData.lastName}
        onChange={handleInputChange}
        className={fieldErrors.lastName ? "error-border" : ""}
      />
    </div>
    <div className="form-group">
      <label>{checkout.countryLabel}</label>
      <select
        name="country"
        value={formData.country}
        onChange={handleInputChange}
        className={fieldErrors.country ? "error-border" : ""}
      >
        <option value="">{checkout.selectCountryOption}</option>
        {countries.map(country => (
          <option key={country} value={country}>
            {country}
          </option>
        ))}
      </select>
    </div>
    <div className="form-group">
      <label>{checkout.addressLine1Label}</label>
      <input
        type="text"
        name="address"
        value={formData.address}
        onChange={handleInputChange}
        className={fieldErrors.address ? "error-border" : ""}
      />
    </div>
    <div className="form-group">
      <label>{checkout.addressLine2Label}</label>
      <input type="text" name="apartment" value={formData.apartment} onChange={handleInputChange} />
    </div>
    <div className="form-group">
      <label>{checkout.cityLabel}</label>
      <input
        type="text"
        name="city"
        value={formData.city}
        onChange={handleInputChange}
        className={fieldErrors.city ? "error-border" : ""}
      />
    </div>
    <div className="form-group">
      <label>{checkout.zipCodeLabel}</label>
      <input
        type="text"
        name="zipCode"
        value={formData.zipCode}
        onChange={handleInputChange}
        className={fieldErrors.zipCode ? "error-border" : ""}
      />
    </div>
    <div className="form-group">
      <label>{checkout.phoneLabel}</label>
      <input
        type="tel"
        name="phone"
        value={formData.phone}
        onChange={handleInputChange}
        className={fieldErrors.phone ? "error-border" : ""}
      />
    </div>
    <div className="form-group form-group-last">
      <label>{checkout.emailLabel}</label>
      <input
        type="email"
        name="email"
        value={formData.email}
        onChange={handleInputChange}
        className={fieldErrors.email ? "error-border" : ""}
      />
    </div>
  </>
);

export default BillingFormFields;
